import { createAction, props } from '@ngrx/store';
import { IGovIdProof } from '../models/govId.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

// CURRENT
export const loadProofGovIds = createAction('[ProofGovId] Load ProofGovIds', props<{ request: string }>());

export const loadProofGovIdsSuccess = createAction('[ProofGovId] Load ProofGovIds Success', props<{ response: IGovIdProof }>());

export const loadProofGovIdsFailure = createAction(
  '[ProofGovId] Load ProofGovIds Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

// PREVIOUS
export const loadPreviousProofGovIds = createAction('[ProofGovId] Load Previous ProofGovIds', props<{ request: string }>());

export const loadPreviousProofGovIdsSuccess = createAction(
  '[ProofGovId] Load Previous ProofGovIds Success',
  props<{ response: IGovIdProof[] }>()
);

export const loadPreviousProofGovIdsFailure = createAction(
  '[ProofGovId] Load Previous ProofGovIds Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
